import { UIElement, UIElementTypes } from '../element';
import TextUiListElement from './TextUiListElement.svelte';
import '../../types';
import { createBangleJSUiCode } from './bangleCode';
import { isPointInRectangle } from '../../utils/helpers';
import { elementSelectionStore } from '../../stores/elementsSelection';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../constants';
export var TextAlignmentTypes;
(function (TextAlignmentTypes) {
    TextAlignmentTypes["CENTER"] = "CENTER";
    TextAlignmentTypes["LEFT"] = "LEFT";
})(TextAlignmentTypes || (TextAlignmentTypes = {}));
export class UIText extends UIElement {
    constructor(args) {
        super(UIElementTypes.TEXT, args.x, args.y, args.z, args.name, args.id);
        this.text = args.text;
        this.width = args.width || 50;
        this.fontSize = args.fontSize || 20;
        this.lineCount = args.lineCount || 1;
        this.boxShowing = args.boxShowing || false;
        this.height = this.fontSize * this.lineCount + this.lineCount;
        this.textAlignment = args.textAlignment || TextAlignmentTypes.LEFT;
        this.fitText = args.fitText || false;
        this.group = args.group;
    }
    convertToCode() {
        return createBangleJSUiCode(this.x, this.y, this.z, this.getRenderBox(), this.name, this.width, this.text.replace(/\n/g, '\\n'), this.lineCount, this.fontSize, this.textAlignment, this.fitText);
    }
    convertToUiElement(mountPoint, uiElement, origin) {
        return new TextUiListElement({ target: mountPoint, props: { uiElement, origin } });
    }
    isSelected(pointerX, pointerY) {
        return isPointInRectangle(pointerX, pointerY, { x: this.x, y: this.y }, {
            x: this.x + this.width,
            y: this.y + this.height
        });
    }
    getFont(fontSize) {
        return `${fontSize}px sans-serif`;
    }
    renderElement(ctx, originCoords) {
        const selected = elementSelectionStore.isSelected(this);
        const x = this.x + originCoords.x;
        const y = this.y + originCoords.y;
        ctx.font = this.getFont(this.fontSize);
        ctx.lineWidth = 3;
        this.height = this.fontSize * this.lineCount + this.lineCount;
        let activeFontSize = this.fontSize;
        if (this.fitText) {
            let overallLength = ctx.measureText(this.text).width;
            while (overallLength / this.lineCount > this.width && activeFontSize > 0) {
                activeFontSize -= 1;
                ctx.font = this.getFont(activeFontSize);
                overallLength = ctx.measureText(this.text).width;
            }
            if (activeFontSize == 0) {
                ctx.font = this.getFont(this.fontSize);
            }
        }
        let rows = [];
        let currentLine = '';
        for (let c of this.text) {
            if (ctx.measureText(currentLine + c).width > this.width) {
                rows.push(currentLine);
                currentLine = c;
            }
            else {
                currentLine += c;
            }
        }
        if (currentLine.length > 0) {
            rows.push(currentLine);
        }
        rows = rows.slice(0, this.lineCount);
        ctx.fillStyle = 'black';
        rows.forEach((row, i) => {
            let alignmentOffset = 0;
            if (this.textAlignment === TextAlignmentTypes.CENTER) {
                alignmentOffset = this.width / 2 - ctx.measureText(row).width / 2;
            }
            ctx.fillText(row, x + alignmentOffset, y - (this.fontSize - activeFontSize) / 2 + (this.fontSize) * (i + 1));
        });
        if (selected || this.boxShowing) {
            const path = new Path2D();
            path.moveTo(x, y);
            path.lineTo(x + this.width, y);
            path.lineTo(x + this.width, y + this.height);
            path.lineTo(x, y + this.height);
            path.lineTo(x, y + this.height);
            path.closePath();
            if (selected) {
                ctx.strokeStyle = 'green';
            }
            else {
                ctx.strokeStyle = 'black';
            }
            // ctx.lineWidth = 10;
            ctx.stroke(path, 'evenodd');
        }
    }
    moveElement(deltaX, deltaY) {
        this.x = this.x + deltaX;
        this.y = this.y + deltaY;
    }
    get isOutsideOfScreenArea() {
        return this.x + this.width <= 0 || this.x >= SCREEN_WIDTH || this.y + this.height <= 0 || this.y >= SCREEN_HEIGHT;
    }
    getRenderBox() {
        return {
            tl: { x: this.x, y: this.y },
            br: { x: this.x + this.width, y: this.y + this.height }
        };
    }
}
